import moment from 'moment/moment'
import PortalVue from 'portal-vue'
import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component'
import VueMoment from 'vue-moment'
import Vuex from 'vuex'
import { Nl2br } from '../shared/component/Nl2br/Nl2br'
import SharedFilters from '../shared/vue/Filters'

import './component/Steps'
import '../shared/component/Form'

Vue.use(Vuex)
Vue.use(SharedFilters)
Vue.use(VueMoment, { moment })
Vue.use(PortalVue)
Vue.component('flatPickr', flatPickr)
Vue.component('nl2br', Nl2br)

Vue.directive('focus', {
  inserted(el) {
    el.focus()
  },
})

Vue.filter('date', (value, format) => moment(value).format(format))

Vue.filter('date_ago', (value, noSuffix) => moment(value).fromNow(noSuffix))

Vue.filter('encodeUriComponent', (value) => encodeURIComponent(value))
